<template>
  <div class="add-address">
    <Title text="新增收货地址" />
    <div class="edit-address">
      <van-address-edit
        :area-list="areaList"
        :show-delete="deleteFlag"
        show-set-default
        :address-info="addressInfo"
        show-search-result
        :search-result="searchResult"
        @change-area="onChangeArea"
        @save="onSave"
        @change-default="onChangeDefault"
      />
    </div>
  </div>
</template>

<script>
import AreaList from "../../common/area";
import Title from "../../components/Title";
import { AddAddress, AddressDetail } from "../../request/api";
export default {
  name: "add-address",
  data() {
    return {
      areaList: AreaList,
      searchResult: [],
      deleteFlag: false,
      areaValues: [],
      defaultFlag: false,
      addressInfo: {}
    };
  },
  components: {
    Title
  },
  created() {
    this.getAddress();
  },
  methods: {
    //地区
    onChangeArea(values) {
      this.areaValues = values;
    },
    //默认地址
    onChangeDefault(value) {
      this.defaultFlag = value;
    },
    //获取单条地址详情
    getAddress() {
      let id = this.$route.params.id;
      if (id) {
        this.deleteFlag = true;
        AddressDetail(id).then(res => {
          let info = res.data;
          this.addressInfo = {
            name: info.receiver,
            tel: info.phone,
            addressDetail: info.address,
            isDefault: info.defaultFlag,
            province: info.provinceCode,
            city: info.cityCode,
            county: info.areaCode,
            areaCode: info.areaCode
          };
        });
      }
    },
    //保存地址
    onSave(content) {
      let obj = {
        receiver: content.name,
        phone: content.tel,
        address: content.addressDetail,
        defaultFlag: this.defaultFlag,
        provinceCode: this.areaValues[0].code,
        cityCode: this.areaValues[1].code,
        areaCode: this.areaValues[2].code
      };
      AddAddress(obj).then(res => {
        if (res.status == 200) {
          this.$router.push("/address");
        } else {
          this.$toast(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.add-address {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
</style>